import styled from 'styled-components'
import {
  flexDirection,
  FlexDirectionProps,
  grid,
  GridProps,
} from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { LANDING_BASIC_HEADER_PADDING_INLINE } from 'Constants/Landing'

import { gap, GapProps } from 'Services/Styles'

const shouldForwardProp = (prop: string) =>
  !['gridTemplateColumns', 'flexDirection'].includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<GridProps & GapProps>`
  display: grid;
  width: 100%;
  color: ${themeGet('colors.primary.main')};
  gap: ${themeGet('space.3')}px;
  padding-inline: ${themeGet(`space.${LANDING_BASIC_HEADER_PADDING_INLINE}`)}px;

  ${grid}
  ${gap}
`

export const Item = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps & GapProps>`
  display: flex;
  align-items: center;

  svg {
    flex-shrink: 0;
  }

  ${flexDirection}
  ${gap}
`
